import Navbar from "./Navbar"
import Contact from "./Contact"
import { DEVELOPERS_SECTION_DETAILS } from "../../lib/lib"
import "./Developer.css"
import Card from "./Card"

function Developers() {
  let cards = DEVELOPERS_SECTION_DETAILS.map((item, index) => <Card key={item.name + index} name={item.name} role={item.role} image={item.image} />)
  return (
    <div className="developer">
      <Navbar />
      <h1 style={{
  width: '100%',
  textAlign: 'center',
  fontSize: '36px',
  fontWeight: 750,
  marginBottom: '40px',
  color: 'blue'
}}>
  Our Team
</h1>


        <div className="dev-cards">
          {cards}
        </div>
      <Contact />
    </div>
  )
}

export default Developers